module.exports = __webpack_public_path__ + "img/logo_name.eec3fd4e.png";